import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-container">
          {/* ABOUT Emeline 栏目 */}
          <div className="footer-column">
            <h3 className="footer-title">ABOUT Emeline</h3>
            <ul className="footer-links">
              <li>
                <Link to="/shipping" onClick={toTop}>
                  Shipping
                </Link>
              </li>

              <li>
                <Link to="/returns" onClick={toTop}>
                  Returns Policy
                </Link>
              </li>
              <li>
                <Link to="/privacy" onClick={toTop}>
                  Privacy Policy
                </Link>
              </li>

              <li>
                <Link to="/terms" onClick={toTop}>
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* LOCATION 栏目 */}
          <div className="footer-column">
            <h3 className="footer-title">CONNECT</h3>
            <div className="footer-info">
              <p>Sheeriff Green</p>
              <p>BridgetMax82285@outlook.com</p>
              <p>6107 Katherine Rd</p>
              <p>Rex</p>
              <p>30273</p>
              <p>United States of America</p>
              <p>Georgia</p>
              <p>Call us:+1 5043691581</p>
            </div>
          </div>

          {/* CONTACT 栏目 */}
          <div className="footer-column">
            <h3 className="footer-title">CONTACT</h3>
            <div className="footer-info">
              <p>
                <strong>Monday-Friday:</strong>
              </p>
              <p>9.30am to 4.00pm</p>
              <p className="hours-gap">
                <strong>Sat, Sun & Public Hols.:</strong>
              </p>
              <p>Closed</p>
            </div>
          </div>
        </div>

        {/* 支付方式和版权信息 */}
        <div className="footer-bottom">
          <div className="payment-methods">
            <img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjMwIiBmaWxsPSIjMDAzMDg3IiByeD0iMyIvPjx0ZXh0IHg9IjI1IiB5PSIyMCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LXdlaWdodD0iYm9sZCI+VklTQTwvdGV4dD48L3N2Zz4="
              alt="Visa"
            />
            <img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjMwIiBmaWxsPSIjMDAzMDg3IiByeD0iMyIvPjx0ZXh0IHg9IjI1IiB5PSIyMCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjkiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtd2VpZ2h0PSJib2xkIj5QYXlQYWw8L3RleHQ+PC9zdmc+"
              alt="PayPal"
            />
            <img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjMwIiBmaWxsPSIjZWIwMDFiIiByeD0iMyIvPjxjaXJjbGUgY3g9IjIwIiBjeT0iMTUiIHI9IjgiIGZpbGw9IiNmZjVmMDAiIG9wYWNpdHk9IjAuOCIvPjxjaXJjbGUgY3g9IjMwIiBjeT0iMTUiIHI9IjgiIGZpbGw9IiNmZjVmMDAiIG9wYWNpdHk9IjAuOCIvPjwvc3ZnPg=="
              alt="Mastercard"
            />

            <img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjMwIiBmaWxsPSIjZmZmIiByeD0iMyIvPjx0ZXh0IHg9IjI1IiB5PSIxMiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEwIiBmaWxsPSIjNTI4NWY0IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LXdlaWdodD0iYm9sZCI+RzwvdGV4dD48dGV4dCB4PSIyNSIgeT0iMjQiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSI4IiBmaWxsPSIjNTI4NWY0IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5QYXk8L3RleHQ+PC9zdmc+"
              alt="Google Pay"
            />
          </div>

          <div className="footer-copyright">
            <p>
              Copyright 2025 © <strong>Emeline Publications</strong>
            </p>
          </div>

          {/* 回到顶部按钮 */}
          <button
            className="back-to-top"
            onClick={scrollToTop}
            aria-label="Back to top"
          >
            ↑
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
